import React from "react";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class RouteErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Surface the real cause so we can diagnose retry-loops on /parent etc.
    // eslint-disable-next-line no-console
    console.error("[RouteErrorBoundary] caught error:", error, "\nComponent stack:", info.componentStack);
  }

  handleRetry = () => {
    sessionStorage.removeItem("chunk-retry");
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4 p-6 text-center">
          <p className="text-lg font-medium text-foreground">
            Something went wrong loading this page.
          </p>
          <p className="text-sm text-muted-foreground">
            This can happen on slow connections. Tap below to try again.
          </p>
          <button
            onClick={this.handleRetry}
            className="px-6 py-3 rounded-lg bg-primary text-primary-foreground font-medium text-base"
          >
            Tap to retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
